import { render, staticRenderFns } from "./TemplatesHeader.vue?vue&type=template&id=0c8cef61&scoped=true&"
import script from "./TemplatesHeader.vue?vue&type=script&lang=ts&"
export * from "./TemplatesHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TemplatesHeader.vue?vue&type=style&index=0&id=0c8cef61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8cef61",
  null
  
)

export default component.exports